import { MailOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { BRAND } from '@/constants/brand';
import { emailFieldRules } from '@/utils/validation';

interface EmailFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label?: string;
  placeholder?: string;
}

export function EmailField<T extends FieldValues>({
  control,
  name,
  label = 'Email',
  placeholder = 'admin@example.com',
}: EmailFieldProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={emailFieldRules}
      render={({ field, fieldState }) => (
        <Form.Item
          label={label}
          required
          validateStatus={fieldState.error ? 'error' : ''}
          help={fieldState.error?.message}
        >
          <Input
            {...field}
            type="email"
            size="large"
            status={fieldState.error ? 'error' : undefined}
            prefix={<MailOutlined style={{ color: BRAND.primary, fontSize: 15 }} />}
            placeholder={placeholder}
            autoComplete="email"
          />
        </Form.Item>
      )}
    />
  );
}
